import createInformesSectionPage from "./SectionPageFactory";

const InformesTesoreriaComprasPage = createInformesSectionPage(
  "Tesorería · Facturas y soportes",
  "Control de facturas de compras registradas contra las cajas y notas de gasto declaradas en las rendiciones."
);

export default InformesTesoreriaComprasPage;
